import { Accordion, AccordionDetails, AccordionSummary, Box, Dialog, DialogContent, DialogTitle, Grid, MenuItem, Skeleton, Typography, useMediaQuery, useTheme } from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ClearIcon from '@mui/icons-material/Clear';
import { useEffect, useState } from 'react'
import InputTextField from '../../../component/input/inputTextField';
import FilterSelect from '../../../component/select/filterSelect';
import ButtonCustom from '../../../component/button/buttonCustom';
import { icons } from '../../../constants/images';
import PDFViewer from '../../../component/viewer/pdfViewer';
import FileApi from '../../../api/file/file.api';
import BoxDoc from '../../../component/boxDoc/boxDoc';
import moment from 'moment';
import { useDropzone } from 'react-dropzone';
import { swalError, swalSuccess } from '../../../component/notification/swal';
import FolderApi from '../../../api/folder/folder.api';
type PropsDialogCreate = {
    file?: any
    openFile: boolean
    setOpenFile: any
    setFile?: any
    inputFolder?: any,
    loadDataLevel?: any
    setLevelFiles?: any
}
export default function DialogOpenFile(props: PropsDialogCreate) {
    const theme = useTheme();

    const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));

    const { file, setFile, setOpenFile, openFile, inputFolder, loadDataLevel, setLevelFiles } = props
    const [url, setUrl] = useState<string>('')
    const [detail, setDetail] = useState<any>()
    // const [openFile, setOpenFile] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingFile, setLoadingFile] = useState<boolean>(false)
    const [edit, setEdit] = useState<boolean>(false)
    const [history, setHistory] = useState<boolean>(false)
    const [newFile, setNewFile] = useState<boolean>(false)
    const [files, setFiles] = useState<any>([])
    const [detailVersions, setDetailVersions] = useState<any>([])
    const [documentSize, setDocumentSize] = useState<any>([])
    const [documentType, setDocumentType] = useState<any>([])
    const [index, setIndex] = useState<any>({
        size: null,
        Type: null
    })
    const { getRootProps, getInputProps, open, acceptedFiles, fileRejections } = useDropzone({
        noClick: true,
        noKeyboard: true,
        maxSize: index?.size && +index?.size?.documentSizeValue || 10000000,
        accept: index?.type && JSON.parse(index?.type?.mimeType) || {
            'image/png': ['.png'],
            'image/jpeg': ['.jpeg'],
            "application/pdf": [".pdf"],
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                [".docx"],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
            "application/msword": [".doc"],
        },
        onDropRejected: (fileRejections) => {
            swalError(fileRejections[0].errors.map((x) => x.code === 'file-invalid-type' ? 'ไม่สามารถเพิ่มไฟล์ประเภทนี้ได้' : x.code === 'file-too-large' ? 'ไฟล์มีขนาดใหญ่เกินไป' : 'ไม่สามารถเพิ่มไฟล์นี้ได้').join('/'))
        },
        onDrop(acceptedFiles, fileRejections, event) {
            setFiles(acceptedFiles)
        },
    });
    const getFileDownload = async () => {
        const res = await FileApi.getFileDownload(file?.idFile)
        const blob = new Blob([res.data], { type: file.fileType });
        setUrl(URL.createObjectURL(blob))

    }

    const getFileDetail = async () => {

        setLoading(true)
        await FileApi.getFile(file?.idFile).then((res: any) => {
            const data = res.data
            setDetail({
                ...data.result.fileFormDocument,
                fileName: file?.fileName || data.result.fileName,
                fileLocation: file?.fileLocation || data.result.fileLocation
            })
            setFile(data.result)

            setDetailVersions(data.result.detailVersions)
            setIndex({
                size: documentSize.length > 0 ? documentSize.find((x: any) => x.idDocumentSize === data.result.idDocumentSize) : null,
                type: documentType.length > 0 ? documentType.find((x: any) => x.idDocumentType === data.result.idDocumentType) : null
            })
            const ff = new Uint8Array(data.result.fileData.data)
            const blob = new Blob([ff], { type: data.result.fileType });
            setUrl(URL.createObjectURL(blob))
            setLoading(false)
        }).catch(async (e: any) => {
            setLoading(false)
            setNewFile(false)
            setUrl('')
            setDetail(null)
            setFiles([])
            setEdit(false)
            setFile(null)
            swalError("ไม่มีไฟล์นี้ในระบบ")
            setOpenFile(false)
        })
    }

    const getDocumentSize = async () => {
        const res = await FolderApi.getDocumentSize()
        const data = res.data
        if (data?.success) {
            setDocumentSize(data.result)
        }
    }
    const getDocumentType = async () => {
        const res = await FolderApi.getDocumentType()
        const data = res.data
        if (data?.success) {
            setDocumentType(data.result)
        }
    }
    useEffect(() => {
        if (openFile) {
            // getFileDownload()
            getFileDetail()
            getDocumentSize()
            getDocumentType()
        }
    }, [openFile])

    const updateFile = async () => {
        const formData = new FormData();
        if (files?.length > 0) {
            formData.append("file", files[0])
        }
        formData.append("info", JSON.stringify(detail))


        await FileApi.patchFile(file.idFile, formData).then(async (res) => {
            if (res?.data?.success) {
                // if (stepView === 1) {
                //     const data = await loadDataLevel(inputFolder.idReferFolder)
                //     setLevel1(data)
                // }
                // if (stepView === 2) {
                //     const data = await loadDataLevel(inputFolder.idReferFolder)
                //     setLevel2(data)
                // }
                // if (stepView === 3) {
                //     const data = await loadDataLevel(inputFolder.idReferFolder)
                //     setLevel3(data)
                // }
                // if (stepView === 4) {
                //     const data = await loadDataLevel(inputFolder.idReferFolder)
                //     setLevel4(data)
                // }
                if(inputFolder?.idReferFolder){
                    const data = await loadDataLevel(inputFolder.idReferFolder)
                    const newArray = new Array(inputFolder.layer)
    
                    setLevelFiles([...newArray, ...data.detailFiles])
                }
             
                // loadData()
                setLoadingFile(false)
                setOpenFile(false)
                setEdit(false)
                setNewFile(false)
                setFiles([])
                swalSuccess("อัพเดทไฟล์สำเร็จ")
            } else {
                setLoadingFile(false)
                swalError(res.data.description || res.data.message);
            }

        }).catch((error: any) => {
            setLoadingFile(false)
            swalError(error.response?.data?.description || error.response?.data?.message || 'อัพเดทไฟล์ไม่สำเร็จ');
        })
    }


    return (
        <Dialog
            fullWidth={!fullScreen}
            fullScreen={fullScreen}
            maxWidth={false}
            sx={{ maxWidth: '1329px', margin: 'auto', }}
            open={openFile}
            onClose={() => {
                setFile(null)
                setOpenFile(false)
            }}>
            {/* <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px" }} onClick={() => {
                    setFile(null)
                    setOpenFile(false)
                }} />
            </DialogTitle> */}
            <DialogContent sx={{ padding: '0px' }}>
                <Box sx={{ display: { lg: 'flex', xs: 'block' } }}>
                    <Box sx={{ display: { lg: 'block', xs: 'none' }, width: { lg: '63%', xs: '100%' }, height: '800px', background: "#F8F9FB", padding: '40px 32px' }}>
                        {!newFile ?
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", marginBottom: "20px" }}>
                                    <Typography>
                                        {file?.fileName}
                                    </Typography>
                                    <div style={{ display: 'flex', alignItems: "center", cursor: 'pointer' }} onClick={() => setHistory(true)}>
                                        <AccessTimeIcon sx={{ fontSize: '16px' }} />
                                        <Typography>
                                            ประวัติเวอร์ชั่น
                                        </Typography>
                                    </div>

                                </div>

                                {loading ? <Skeleton height={'75vh'} /> : file?.fileExtention === 'pdf' ? <PDFViewer file={url} style={{ width: '100%', height: '75vh' }} /> :
                                    (file?.fileExtention === 'docx' || file?.fileExtention === 'xlsx' || file?.fileExtention === 'txt') ?
                                        <Grid container columns={8} spacing={2} sx={{
                                        }}>
                                            <BoxDoc id={file?.idFile} style={{ borderRadius: '10px' }} icon={<icons.box5 />} title={file?.fileName} type='file' detail={file} file={file} checkbox />
                                        </Grid> :
                                        <div style={{ width: '100%', height: '75vh' }}>
                                            <img src={url} width={'100%'} height={'100%'} />
                                        </div>}
                            </> :
                            files?.length === 0 ?
                                <> <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", marginBottom: "20px" }}>
                                    <Typography>
                                        อัปเดตไฟล์
                                    </Typography>
                                </div>

                                    <div style={{
                                        borderRadius: '10px',
                                        border: '1px dashed #C1C3C7',
                                        padding: '56px',
                                        marginBottom: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '629px'
                                    }} {...getRootProps({ className: 'dropzone' })}>
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
                                            <icons.uploadCloud />
                                            <Typography sx={{ fontSize: '14px', fontWeight: '500', marginTop: '24px' }}>ลากหรือเลือกไฟล์เพื่ออัปโหลด</Typography>
                                            <Typography sx={{ fontSize: '14px', fontWeight: '300', color: 'rgba(0, 0, 0, 0.40)', marginBottom: '24px' }}>ขนาดไม่เกิน {index?.size?.documentSizeName || '10MB'}</Typography>
                                            <ButtonCustom variant={'outlined'}
                                                // endIcon={<icons.downloadButton />}
                                                textButton={'เลือกไฟล์'}
                                                onClick={open}
                                                btnStyle={{
                                                    '&.MuiButton-outlined': {
                                                        color: `#0A77FF !important`,
                                                        border: `1px dashed #0A77FF !important`,
                                                        backgroundColor: '#fff !important',
                                                        borderRadius: "10px !important",
                                                        '&:hover': {
                                                            color: `#0A77FF  !important`,
                                                            border: `1px dashed #0A77FF !important`,
                                                            backgroundColor: '#fff !important'
                                                        },
                                                    },
                                                }} />
                                        </div>
                                        <input {...getInputProps()} />

                                    </div>
                                </>
                                :
                                <> <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", marginBottom: "20px" }}>
                                    <Typography>
                                        อัปเดตไฟล์
                                    </Typography>
                                </div>
                                    <Grid container columns={8} spacing={2} sx={{
                                    }}>
                                        {files.map((x: any, i: number) => {
                                            return (
                                                <BoxDoc id={x.idFile} icon={<icons.box5 />} title={x?.name} dropDown checkbox />
                                            )
                                        })}

                                    </Grid></>
                        }
                    </Box>
                    <Box sx={{ width: { lg: '37%', xs: '100%' }, height: '800px', background: "#fff", padding: '40px 32px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative' }}>
                        {!history ? <>
                            <div style={{ overflowY: 'auto', marginBottom: '20px' }}>
                                <Accordion defaultExpanded sx={{
                                    display: { lg: 'none', xs: 'block' },
                                    padding: '0px',
                                    boxShadow: 'none', ':before': {
                                        content: '""',
                                        height: "0px"
                                    }
                                }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        style={{ padding: '0px' }}
                                    >
                                        <Typography sx={{ fontWeight: '500' }}>เอกสารที่อัปโหลด</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '0px' }}>
                                        {!newFile ?
                                            <>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", marginBottom: "20px" }}>
                                                    <Typography>
                                                        {file?.fileName}
                                                    </Typography>
                                                    <div style={{ display: 'flex', alignItems: "center", cursor: 'pointer' }} onClick={() => setHistory(true)}>
                                                        <AccessTimeIcon sx={{ fontSize: '16px' }} />
                                                        <Typography>
                                                            ประวัติเวอร์ชั่น
                                                        </Typography>
                                                    </div>

                                                </div>
                                                {file?.fileExtention === 'pdf' ? <PDFViewer file={url} style={{ width: '100%', height: '75vh' }} /> :
                                                    (file?.fileExtention === 'docx' || file?.fileExtention === 'xlsx' || file?.fileExtention === 'txt') ?
                                                        <Grid container columns={8} spacing={2} sx={{
                                                        }}>
                                                            <BoxDoc id={file?.idFile} style={{ borderRadius: '10px' }} icon={<icons.box5 />} title={file?.fileName} type='file' detail={file} file={file} checkbox />
                                                        </Grid> :
                                                        <div style={{ width: '100%', height: '75vh' }}>
                                                            <img src={url} width={'100%'} height={'100%'} style={{ objectFit: "contain" }} />
                                                        </div>}
                                            </> :
                                            files?.length === 0 ?
                                                <> <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", marginBottom: "20px" }}>
                                                    <Typography>
                                                        อัปเดตไฟล์
                                                    </Typography>
                                                </div>

                                                    <div style={{
                                                        borderRadius: '10px',
                                                        border: '1px dashed #C1C3C7',
                                                        padding: '56px',
                                                        marginBottom: '20px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: '329px'
                                                    }} {...getRootProps({ className: 'dropzone' })}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
                                                            <icons.uploadCloud />
                                                            <Typography sx={{ fontSize: '14px', fontWeight: '500', marginTop: '24px' }}>ลากหรือเลือกไฟล์เพื่ออัปโหลด</Typography>
                                                            <Typography sx={{ fontSize: '14px', fontWeight: '300', color: 'rgba(0, 0, 0, 0.40)', marginBottom: '24px' }}>ขนาดไม่เกิน {index?.size?.documentSizeName || '10MB'}</Typography>
                                                            <ButtonCustom variant={'outlined'}
                                                                // endIcon={<icons.downloadButton />}
                                                                textButton={'เลือกไฟล์'}
                                                                onClick={open}
                                                                btnStyle={{
                                                                    '&.MuiButton-outlined': {
                                                                        color: `#0A77FF !important`,
                                                                        border: `1px dashed #0A77FF !important`,
                                                                        backgroundColor: '#fff !important',
                                                                        borderRadius: "10px !important",
                                                                        '&:hover': {
                                                                            color: `#0A77FF  !important`,
                                                                            border: `1px dashed #0A77FF !important`,
                                                                            backgroundColor: '#fff !important'
                                                                        },
                                                                    },
                                                                }} />
                                                        </div>
                                                        <input {...getInputProps()} />

                                                    </div>
                                                </>
                                                :
                                                <> <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", marginBottom: "20px" }}>
                                                    <Typography>
                                                        อัปเดตไฟล์
                                                    </Typography>
                                                </div>
                                                    <Grid container columns={8} spacing={2} sx={{
                                                    }}>
                                                        {files.map((x: any, i: number) => {
                                                            return (
                                                                <BoxDoc id={x.idFile} icon={<icons.box5 />} title={x?.name} dropDown checkbox />
                                                            )
                                                        })}

                                                    </Grid></>
                                        }
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion defaultExpanded sx={{
                                    padding: '0px',
                                    boxShadow: 'none', ':before': {
                                        content: '""',
                                        height: "0px"
                                    }
                                }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        style={{ padding: '0px' }}
                                    >
                                        <Typography sx={{ fontWeight: '500' }}>ข้อมูลเอกสาร</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '0px' }}>
                                        <InputTextField heading='ชื่อเอกสาร' disabled={!edit} value={detail?.fileName || ''} onchange={(e) => setDetail({ ...detail, fileName: e.target.value })} />
                                        <InputTextField heading='ตำแหน่งเอกสารจริง' disabled={!edit} value={detail?.fileLocation || ''} onchange={(e) => setDetail({ ...detail, fileLocation: e.target.value })} />

                                    </AccordionDetails>
                                </Accordion>
                                <Accordion defaultExpanded sx={{
                                    boxShadow: 'none', ':before': {
                                        content: '""',
                                        height: "0px"
                                    }
                                }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        style={{ padding: '0px' }}

                                    >
                                        <Typography sx={{ fontWeight: '500' }}>ดัชนีข้อมูลเอกสาร</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '0px' }}>
                                        {detail?.formDocument_0_Name && <InputTextField disabled={!edit} heading={detail.formDocument_0_Name} value={detail.formDocument_0_Value} onchange={(e) => {
                                            setDetail({ ...detail, formDocument_0_Value: e.target.value })
                                        }} />}
                                        {detail?.formDocument_1_Name && <InputTextField disabled={!edit} heading={detail.formDocument_1_Name} value={detail.formDocument_1_Value} onchange={(e) => {
                                            setDetail({ ...detail, formDocument_1_Value: e.target.value })
                                        }} />}
                                        {detail?.formDocument_2_Name && <InputTextField disabled={!edit} heading={detail.formDocument_2_Name} value={detail.formDocument_2_Value} onchange={(e) => {
                                            setDetail({ ...detail, formDocument_2_Value: e.target.value })
                                        }} />}
                                        {detail?.formDocument_3_Name && <InputTextField disabled={!edit} heading={detail.formDocument_3_Name} value={detail.formDocument_3_Value} onchange={(e) => {
                                            setDetail({ ...detail, formDocument_3_Value: e.target.value })
                                        }} />}
                                        {detail?.formDocument_4_Name && <InputTextField disabled={!edit} heading={detail.formDocument_4_Name} value={detail.formDocument_4_Value} onchange={(e) => {
                                            setDetail({ ...detail, formDocument_4_Value: e.target.value })
                                        }} />}
                                        {detail?.formDocument_5_Name && <InputTextField disabled={!edit} heading={detail.formDocument_5_Name} value={detail.formDocument_5_Value} onchange={(e) => {
                                            setDetail({ ...detail, formDocument_5_Value: e.target.value })
                                        }} />}
                                        {detail?.formDocument_6_Name && <InputTextField disabled={!edit} heading={detail.formDocument_6_Name} value={detail.formDocument_6_Value} onchange={(e) => {
                                            setDetail({ ...detail, formDocument_6_Value: e.target.value })
                                        }} />}
                                        {detail?.formDocument_7_Name && <InputTextField disabled={!edit} heading={detail.formDocument_7_Name} value={detail.formDocument_7_Value} onchange={(e) => {
                                            setDetail({ ...detail, formDocument_7_Value: e.target.value })
                                        }} />}
                                        {detail?.formDocument_8_Name && <InputTextField disabled={!edit} heading={detail.formDocument_8_Name} value={detail.formDocument_8_Value} onchange={(e) => {
                                            setDetail({ ...detail, formDocument_8_Value: e.target.value })
                                        }} />}
                                        {detail?.formDocument_9_Name && <InputTextField disabled={!edit} heading={detail.formDocument_9_Name} value={detail.formDocument_9_Value} onchange={(e) => {
                                            setDetail({ ...detail, formDocument_9_Value: e.target.value })
                                        }} />}

                                    </AccordionDetails>
                                </Accordion>

                            </div>
                            <div style={{ display: "flex", justifyContent: 'flex-end' }}>
                                {edit && <ButtonCustom variant={'outlined'}
                                    textButton={'อัปเดตไฟล์'}
                                    onClick={() => {
                                        setNewFile(true)
                                        setFiles([])
                                    }}
                                    style={{ marginRight: '4px' }}
                                    btnStyle={{
                                        '&.MuiButton-outlined': {
                                            color: `#0A77FF !important`,
                                            border: `2px solid #0A77FF !important`,
                                            borderRadius: "10px !important",
                                            '&:hover': {
                                                color: `#0A77FF  !important`,
                                                border: `2px solid #0A77FF !important`,
                                                backgroundColor: '#EFFFF7 !important'
                                            },
                                        },
                                    }} />}
                                {(!edit ? <ButtonCustom variant={'outlined'}
                                    startIcon={<icons.bcircle />}
                                    textButton={'อัปเดตเอกสาร'}
                                    onClick={() => {
                                        setEdit(true)
                                        setFiles([])
                                    }}
                                    style={{ marginRight: '4px' }}
                                    btnStyle={{
                                        '&.MuiButton-outlined': {
                                            color: `#323539 !important`,
                                            border: `2px solid #E5E5E7 !important`,
                                            borderRadius: "10px !important",
                                            '&:hover': {
                                                color: `#323539  !important`,
                                                border: `2px solid #E5E5E7 !important`,
                                                backgroundColor: '#EFFFF7 !important'
                                            },
                                        },
                                    }} /> :
                                    <ButtonCustom variant={'outlined'}
                                        // startIcon={<icons.bcircle />}
                                        textButton={'ยกเลิก'}
                                        onClick={() => {
                                            setNewFile(false)
                                            setFiles([])
                                            setEdit(false)
                                            getFileDetail()
                                        }}
                                        style={{ marginRight: '4px' }}
                                        btnStyle={{
                                            '&.MuiButton-outlined': {
                                                color: `#323539 !important`,
                                                border: `2px solid #E5E5E7 !important`,
                                                borderRadius: "10px !important",
                                                '&:hover': {
                                                    color: `#323539  !important`,
                                                    border: `2px solid #E5E5E7 !important`,
                                                    backgroundColor: '#EFFFF7 !important'
                                                },
                                            },
                                        }} />)}
                                <ButtonCustom variant={'outlined'}
                                    // endIcon={<icons.downloadButton />}
                                    textButton={edit ? 'อัปเดตเอกสาร' : 'เสร็จสิ้น'}
                                    onClick={() => {
                                        if (edit) {
                                            updateFile()
                                        } else {
                                            setNewFile(false)
                                            setUrl('')
                                            setDetail(null)
                                            setFiles([])
                                            setEdit(false)
                                            setFile(null)
                                            setOpenFile(false)
                                        }

                                    }}
                                    btnStyle={{
                                        '&.MuiButton-outlined': {
                                            color: `#fff !important`,
                                            border: `2px solid #026735 !important`,
                                            backgroundColor: '#026735 !important',
                                            borderRadius: "10px !important",
                                            '&:hover': {
                                                color: `#fff  !important`,
                                                border: `2px solid #026735 !important`,
                                                backgroundColor: '#026735 !important'
                                            },
                                        },
                                    }} />

                            </div>
                        </> : <>
                            <div style={{ overflowY: 'auto', marginBottom: '20px', }}>
                                <div style={{ display: 'flex' }}>
                                    <Typography onClick={() => { setHistory(false) }} sx={{ marginRight: '12px', cursor: 'pointer' }}>{' < '}</Typography>
                                    <Typography sx={{ fontWeight: '500' }}>ประวัติเวอร์ชั่น</Typography>
                                </div>
                                {detailVersions?.map((x: any) => {
                                    return (
                                        <div style={{ padding: '8px', borderBottom: '1px solid #E5E5E7' }}>
                                            <Typography sx={{ fontWeight: '500' }}>{new Date(x?.createDate).toLocaleString('Th-th', { dateStyle: 'long', timeStyle: 'medium' }) + '  ' + `เวอร์ชั่น ${x?.version}`}</Typography>
                                            <Typography sx={{ fontWeight: '300' }}>โดย {x?.creator?.employeeFirstname} {x?.creator?.employeeLastname}</Typography>
                                        </div>
                                    )
                                })}


                            </div>
                            <div style={{ display: "flex", justifyContent: 'flex-end' }}>

                                <ButtonCustom variant={'outlined'}
                                    // endIcon={<icons.downloadButton />}
                                    textButton={'เสร็จสิ้น'}
                                    // onClick={() => { navigate('/create-my-documents') }}
                                    btnStyle={{
                                        '&.MuiButton-outlined': {
                                            color: `#fff !important`,
                                            border: `2px solid #026735 !important`,
                                            backgroundColor: '#026735 !important',
                                            borderRadius: "10px !important",
                                            '&:hover': {
                                                color: `#fff  !important`,
                                                border: `2px solid #026735 !important`,
                                                backgroundColor: '#026735 !important'
                                            },
                                        },
                                    }} />

                            </div>
                        </>
                        }
                        <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px", position: 'absolute', top: '20px', right: '16px' }} onClick={() => {
                            setNewFile(false)
                            setUrl('')
                            setDetail(null)
                            setFiles([])
                            setEdit(false)
                            setFile(null)
                            setOpenFile(false)
                        }} />


                    </Box>
                </Box>
            </DialogContent>

        </Dialog>
    )
}
